<!-- ================阅读拓展馆-博雅美育视频分类====================-->
<template>
    <div class="bymy-classify-container">
        <home-head />
        <div class="bymy-classify-body">
            <div class="bymy-classify-inner" v-loading="loading">
                <!-- 标题区 -->
                <div class="bymy-classify-header">
                    <div class="bymy-classify-title-box">
                        <div class="bymy-classify-title">{{ itemInfo.itemName  }}</div>
                        <div class="bymy-classify-subtitle">{{ itemInfo.itemClassifyName }}</div>
                    </div>
                    <div class="back-btn" @click="goBack">
                        <span class="back-arrow">←</span>
                        <span>返回</span>
                    </div>
                </div>

                <!-- 搜索栏 -->
                <div class="bymy-classify-search">
                    <input class="search-input" type="text" placeholder="请输入关键词" v-model="searchKeyword" @keyup.enter="handleSearch" />
                    <div class="search-btn" @click="handleSearch">搜索</div>
                </div>

                <!-- 视频分类卡片 -->
                <div class="bymy-classify-cards">
                    <div class="classify-card cursor" v-for="(item, index) in filteredList" :key="index" @click="handleCardClick(item)">
                        <div class="card-cover">
                            <img :src="item.imgUrl" :alt="item.itemClassifyName" />
                        </div>
                        <div class="card-title" :title="item.itemClassifyName">{{ item.itemClassifyName }}</div>
                    </div>
                </div>

                <!-- 暂无数据 -->
                <div class="empty-state" v-if="!loading && filteredList.length === 0">
                    <div class="empty-icon">
                        <img src="@/assets/image/data_empty.png" alt="暂无数据" />
                    </div>
                    <div class="empty-text">暂无数据</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { infoHumItem } from "@/api/admin/humanityItem";
import homeHead from "@/components/common/homeHead.vue";

export default {
    components: { homeHead },
    name: "bymyClassify",
    data() {
        return {
            loading: false,
            itemId: "",
            searchKeyword: "",
            itemInfo: {},
            classifyList: [],
        }
    },
    computed: {
        filteredList() {
            const keyword = this.searchKeyword.trim();
            if (!keyword) return this.classifyList;
            return this.classifyList.filter(item => {
                const name = item.itemClassifyName || item.itemClassifyName || "";
                const desc = item.itemClassifyName || item.itemClassifyName || "";
                return name.includes(keyword) || desc.includes(keyword);
            });
        }
    },
    watch: {},
    created() {
        if (this.$route.query.itemId) {
            this.itemId = this.$route.query.itemId;
            this.queryItemInfo();
        }
    },
    mounted() {},
    methods: {
        /* ===============查询主题信息及其子分类===================== */
        queryItemInfo() {
            this.loading = true;
            infoHumItem({ itemId: this.itemId }).then(res => {
                if (res.data.code === 1) {
                    this.itemInfo = res.data.data ;
                    this.classifyList = this.itemInfo.classifyList;
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        /* ===============搜索===================== */
        handleSearch() {
            // 搜索关键词已绑定计算属性过滤
        },
        /* ===============跳转===================== */
        goBack() {
            this.$router.back();
        },
        handleCardClick(item) {
            this.$router.push({
                path: "/bymy/videos",
                query: {
                    itemId: item.itemId,
                    businessType: this.$route.query.businessType,
                    collectType: this.$route.query.collectType
                }
            });
        }
    }
}
</script>

<style scoped>
.bymy-classify-container {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.bymy-classify-body {
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0;
    box-sizing: border-box;
    overflow: hidden;
}

.bymy-classify-inner {
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

/* 标题区 */
.bymy-classify-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    flex-shrink: 0;
}

.bymy-classify-title-box {
    display: flex;
    flex-direction: column;
}

.bymy-classify-title {
    font-size: 20px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
    margin-bottom: 8px;
}

.bymy-classify-subtitle {
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

.back-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 28px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.back-btn:hover {
    background-color: #9a1b1b;
}

.back-arrow {
    margin-right: 8px;
    font-size: 16px;
}

/* 搜索栏 */
.bymy-classify-search {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    margin-bottom: 24px;
    flex-shrink: 0;
}

.search-input {
    width: 200px;
    height: 34px;
    line-height: 34px;
    padding: 0 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    outline: none;
    font-size: 14px;
    font-family: sans-serif;
    box-sizing: border-box;
    background-color: #ffffff;
}

.search-input:focus {
    border-color: #b22222;
}

.search-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 20px;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 14px;
    color: #b22222;
    background-color: #ffffff;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.search-btn:hover {
    background-color: #b22222;
    color: #ffffff;
}

/* 卡片列表 */
.bymy-classify-cards {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    box-sizing: border-box;
    overflow-y: auto;
    align-content: flex-start;
    padding-bottom: 20px;
    padding-top: 10px;
}

.bymy-classify-cards::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}
.bymy-classify-cards::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}
.bymy-classify-cards::-webkit-scrollbar-thumb {
    background: #b22222;
    border-radius: 6px;
    border: 3px solid #f1f1f1;
}
.bymy-classify-cards::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.classify-card {
    width: calc(25% - 15px);
    flex-shrink: 0;
    background-color: #ffffff;
    border: 1.5px solid #b22222;
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: all 0.25s ease;
    overflow: hidden;
}

.classify-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.card-cover {
    width: 100%;
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: #f3f4f6;
}

.card-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.card-title {
    width: 100%;
    height: 46px;
    line-height: 46px;
    padding: 0 12px;
    font-size: 15px;
    color: #1f2937;
    font-family: sans-serif;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
}

/* 暂无数据 */
.empty-state {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
}

.empty-icon {
    width: 100px;
    height: 100px;
    margin-bottom: 12px;
}

.empty-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.empty-text {
    font-size: 15px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

@media (max-width: 1024px) {
    .classify-card { width: calc(33.333% - 13.333px); }
}

@media (max-width: 768px) {
    .bymy-classify-header { flex-direction: column; align-items: flex-start; gap: 12px; }
    .bymy-classify-search { width: 100%; }
    .search-input { flex: 1; }
    .classify-card { width: calc(50% - 10px); }
    .card-cover { height: 130px; }
}
</style>
